import { screenSmMax, screenMdMin, screenLgMin, screenXlMin, } from '@spotify-internal/encore-web/core';
import { parsePixelValue } from './parsePixelValue';
export const breakpointValues = {
    sm: parsePixelValue(screenSmMax),
    md: parsePixelValue(screenMdMin),
    lg: parsePixelValue(screenLgMin),
    xl: parsePixelValue(screenXlMin),
};
